// @ts-nocheck
/* eslint-disable */

import React from 'react';
import EntityTable from 'app/components/CRUD/EntityTable';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import moment from 'moment';

const BanksTable: React.FC = () => {
  const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';

  return (
    <EntityTable
      // ============ PAGE CONFIGURATION ============
      pageTitle="Banks"
      pageIcon={AccountBalanceIcon}
      addButtonLabel="AddNewBank"
      
      // ============ NAVIGATION URLs ============
      addPageUrl="/settlements/Banks/new"
      viewPageUrl="/settlements/Banks/:id"
      editPageUrl="/settlements/Banks/:id/edit?came_from=all"
      
      // ============ API CONFIGURATION ============
      getApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/settlements/banks`}
      getApiMethod="GET"
      
      deleteApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/settlements/banks/:id`}
      deleteApiMethod="DELETE"
      
      // ============ RESPONSE CONFIGURATION ============
      responseDataPath="data.data.banks"
      responsePaginationPath="data.data.pagination"
      
      // ============ TABLE CONFIGURATION ============
      idField="id"
      columns={[
        {
          field: 'bank_name_en',
          headerKey: 'BankNameEnglish',
          align: 'center',
        },
        {
          field: 'bank_name_ar',
          headerKey: 'BankNameArabic',
          align: 'center',
        },
        {
          field: 'swift_code',
          headerKey: 'SwiftCode',
          align: 'center',
        },
        {
          field: 'created_at',
          headerKey: 'CreatedAt',
          align: 'center',
          render: (value) => value ? moment(value).format('DD/MM/YYYY HH:mm:ss') : '-',
        },
      ]}
      
      // ============ SEARCH CONFIGURATION ============
      searchQueryParam="search"
      searchPlaceholder="SearchBankNameSwiftCode"
      
      // ============ NO FILTERS ============
      filterFields={[]}
      
      // ============ PERMISSIONS ============
      subsystemName="Banks"
      
      // ============ ACTIONS ============
      showAddButton={true}
      showActions={true}
      showEdit={true}
      showDelete={true}
      deleteConfirmationMessage="AreYouSureDeleteBank"
    />
  );
};

export default BanksTable;